import injectStyles from 'react-jss'
import { styles } from './styles'
import { CreateEditEmailTemplateModal } from './CreateEmailTemplateModal'

export default injectStyles(styles)(CreateEditEmailTemplateModal)
